import ReactHtmlParser from "react-html-parser";
import React from "react";
import styled from "../../lib/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { mainTheme } from "../../lib/theme";

interface PodcastProps {
  episodeNumber?: string;
  title?: string;
  info?: string;
  releaseDate?: string;
  episodeLength?: string;
  youtubeLink?: string;
  itunesLink?: string;
  podbeanLink?: string;
  stitcherLink?: string;
}
const PodcastEpisode: React.FC<PodcastProps> = (props) => {
  return (
    <div
      className={`podcast--wrapper ${props.releaseDate.includes(new Date().getFullYear().toString())
          ? "show"
          : "hide"
        }`}
      data-date={props.releaseDate}
    >
      <Wrapper>
        <div className="podcast-header">
          <span>#{props.episodeNumber}</span>
          <h3>{ReactHtmlParser(props.title)}</h3>
          <span className="release-date">{props.releaseDate}</span>
        </div>
        <div className="podcast-info">
          <p className="podcast--info-text">{ReactHtmlParser(props.info)}</p>
          <div className="podcast--footer">
            <div className="podcast-length">{props.episodeLength}</div>
            <div className="podcast--links">
              <span className="podcast--links--label">Listen on:</span>
              {props.youtubeLink && (
                <a
                  className="podcast--link youtube"
                  target="_blank"
                  href={props.youtubeLink}
                >
                  <i>
                    <FontAwesomeIcon
                      color={mainTheme.color.lightGrey}
                      icon={["fab", "youtube"]}
                    />
                  </i>
                  <span className="podcast--link--text">YouTube</span>
                </a>
              )}
              {props.itunesLink && (
                <a
                  className="podcast--link itunes"
                  target="_blank"
                  href={props.itunesLink}
                >
                  <i>
                    <FontAwesomeIcon
                      color={mainTheme.color.lightGrey}
                      icon={["fab", "itunes-note"]}
                    />
                  </i>
                  <span className="podcast--link--text">iTunes</span>
                </a>
              )}
              {props.stitcherLink && (
                <a
                  className="podcast--link stitcher"
                  target="_blank"
                  href={props.stitcherLink}
                >
                  <i>
                    <FontAwesomeIcon
                      color={mainTheme.color.lightGrey}
                      icon={["fas", "microphone-alt"]}
                    />
                  </i>
                  <span className="podcast--link--text">Stitcher</span>
                </a>
              )}
              {props.podbeanLink && (
                <a
                  className="podcast--link podbean"
                  target="_blank"
                  href={props.podbeanLink}
                >
                  <i>
                    <FontAwesomeIcon
                      color={mainTheme.color.lightGrey}
                      icon={["fas", "microphone"]}
                    />
                  </i>
                  <span className="podcast--link--text">podbean</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default PodcastEpisode;

const Wrapper = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;

  &.hide {
    display: none;
  }

  .podcast-header {
    background: #c1c1c1;
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 5px 5px 0 0;

    span {
      font-family: "Bebas Neue";
      font-weight: bold;
      color: #171717;
      padding: 0 10px;
      font-size: 30px;
      display: inline-block;
    }
    h3 {
      font-family: "Bebas Neue";
      color: #171717;
      font-size: 20px;
      padding: 0 10px;
      line-height: 1em;
      margin: 0 !important;
    }
    .release-date {
      margin-left: auto;
      font-family: "Bebas Neue";
      color: #171717;
      font-size: 20px;
      padding: 0 10px;
      line-height: 1em;
    }
  }
  .podcast-info {
    .podcast--footer {
      display: flex;
      flex-direction: row;

      padding-top: 15px;

      .podcast--links {
        display: flex;
        margin-left: auto;
        a.podcast--link {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: 10px;
          text-decoration: none;
          color: inherit;
          i {
            padding: 5px;
            svg {
              fill: #fff;
            }
            background: ${({ theme }) => theme.color.accent};
            border-radius: 4px 0 0 4px;
            border: 1px solid ${({ theme }) => theme.color.accent};
            height: 30px;
            display: flex;
          }
          span {
            padding: 5px;
            border: 1px solid ${({ theme }) => theme.color.accent};
            line-height: 1;
            border-radius: 0 4px 4px 0;
            color: ${({ theme }) => theme.color.accent};
            height: 30px;

            font-family: "Bebas Neue";
          }
        }
      }
    }

    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1px solid #c1c1c1;
    border-radius: 0 0 5px 5px;
    p {
      margin: 0;
      padding: 0;
    }

    @media (max-width: 760px) {
      .podcast--footer {
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .podcast--links {
          margin: 10px auto;

          a.podcast--link:first-child {
            margin: 0 5px;
          }
        }

        span.podcast--links--label {
          display: none;
        }
      }
    }
  }
`;
